import api from '../apiConnector'

export default class Vehiculier {

    constructor( marque, onReady ) {
        this.marque = marque
        const me = this
        api.post(
            {action:'list_vehicules'},
            (res)=>{
                me.vehicules = res.vehicules
                me.marques = []
                for ( const m in me.vehicules ) {
                    me.marques.push({value:m,label:m})
                }
                me.modeles = this.getModeles(me.marque)
                onReady()
            }
        )
    }

    selectMarque( marque ) {
        this.marque = marque
        this.modeles = this.getModeles(marque)
    }

    getMarques() {
        return this.marques
    }

    getModeles() {
        if ( !this.marque ) return []
        let modeles = []
        for ( const mo of this.vehicules[this.marque] ) {
            modeles.push({value:mo,label:mo})
        }
        return modeles
    }

    getMarque() {
        return this.marque
    }

}
